import React from "react";
import { useFormContext } from "react-hook-form";
import I18n from "i18n-js";

import FormSection from "./FormSection";
import ObjectiveList from "./ObjectiveList";

const ObjectivesAndTasks = ({ team }) => {

  const { watch, setValue, clearErrors, formState: { errors } } = useFormContext();

  return (
    <FormSection
      title={I18n.t("pdp.form.objectives_tasks.title")}
      description={I18n.t("pdp.form.objectives_tasks.description")}
    >
      <ObjectiveList
        team={team}
        objectives={watch("objectives")}
        errors={errors.objectives}
        onChange={objectives => setValue("objectives", objectives)}
        onErrorClear={clearErrors}
      />
    </FormSection>
  );
}

export default ObjectivesAndTasks;
